import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ff63c5fc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "service-list" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "info" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "产品交付", -1))
const _hoisted_5 = { class: "time" }
const _hoisted_6 = { class: "invalid-box" }
const _hoisted_7 = { class: "invalid" }
const _hoisted_8 = ["src"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "invalid-tip" }, "暂无服务记录", -1))

import AppHeader from '@/components/Header.vue'
import deliveryServiceDocumnet from '@/assets/delivery-service-documnet.svg'
import { getTicketList } from '@/apis/complete-machine-delivery'
import appHost from '@/utils/app'
import { statusInfoMap, detailStatusTextMap } from '@/defination/complete-machine-delivery'
import { Toast } from 'vant'
import { onBeforeMount, ref, computed } from 'vue'
import { useRouter } from 'vue-router'
import router from '@/router'
import { List, PullRefresh, Cell } from 'vant'

export default /*#__PURE__*/_defineComponent({
  __name: 'delivery-service-list',
  setup(__props) {

const loading = ref(false)
const finished = ref(false)
const refreshing = ref(false)
const requestError = ref(false)
// import { Button, Icon, Popup, Picker } from 'vant'
const Router = useRouter()
const onLeftClick = function () {
  // appHost.goAppBack()
  Router.go(-1)
}
const queryParams = {
  page: 0,
  per_page: 20,
}
const onRefresh = () => {
  queryParams.page = 0
  initData(true)
}
// let isPopupshow = ref(false)
// let orderButtonText = ref('全部订单')
// function orderTypeHanlder() {
//   isPopupshow.value = true
// }

// let orderTypeColumns = ref(['全部', '产品交付', '培训交付', '其他'])
// const orderTypeOnConfirm: InstanceType<typeof Picker>['onConfirm'] = (value) => {
//   console.log('orderTypeOnConfirm', value)
//   orderButtonText.value = value
//   isPopupshow.value = false
// }

// const orderTypeOnCancel: InstanceType<typeof Picker>['onCancel'] = () => {
//   isPopupshow.value = false
// }

let serviceItemList = ref([])
let invalid = computed(() => {
  return serviceItemList.value.length === 0
})

async function initData(overwrite = false) {
  console.log('initData')
  try {
    // Toast.loading({
    //   message: '加载中...',
    //   forbidClick: true,
    //   loadingType: 'spinner',
    //   duration: 0,
    // })

    let data = await getTicketList(queryParams)
    let formatData = data.data.map((_) => {
      return {
        status: _.status,
        status_test: detailStatusTextMap.get(_.status),
        assign_time: _.assign_time,
        order_no: _.order_no,
        statusInfo: statusInfoMap.get(_.status),
      }
    })
    if (overwrite) {
      serviceItemList.value = formatData
    } else {
      serviceItemList.value = serviceItemList.value.concat(formatData)
    }
    // Toast.clear()
    finished.value = serviceItemList.value.length >= Number(data.total)
    loading.value = false
    refreshing.value = false
  } catch (e) {
    console.log(e)
    queryParams.page = 0
    requestError.value = true
  }
}

function gotoDetail(order_no: string) {
  Router.push({
    name: 'delivery-service-detail',
    query: {
      order_no,
    },
  })
}

// onBeforeMount(async () => {
//   await initData()
// })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AppHeader, {
      title: "交付服务",
      onLeftClick: onLeftClick,
      isReturnLeftEvent: ""
    }),
    _createVNode(_unref(PullRefresh), {
      modelValue: refreshing.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((refreshing).value = $event)),
      onRefresh: onRefresh,
      class: "list-wrap"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(List), {
          loading: loading.value,
          "onUpdate:loading": _cache[0] || (_cache[0] = ($event: any) => ((loading).value = $event)),
          error: requestError.value,
          "onUpdate:error": _cache[1] || (_cache[1] = ($event: any) => ((requestError).value = $event)),
          finished: finished.value,
          "finished-text": "没有更多了",
          "error-text": "加载失败",
          onLoad: initData,
          class: "list-container"
        }, {
          finished: _withCtx(() => [
            _createElementVNode("div", _hoisted_6, [
              _withDirectives(_createElementVNode("div", _hoisted_7, [
                _createElementVNode("img", {
                  width: "80",
                  height: "80",
                  src: _unref(deliveryServiceDocumnet)
                }, null, 8, _hoisted_8),
                _hoisted_9
              ], 512), [
                [_vShow, _unref(invalid)]
              ])
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(serviceItemList), (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "service-item",
                  key: index,
                  onClick: ($event: any) => (gotoDetail(item.order_no))
                }, [
                  _createElementVNode("div", _hoisted_3, [
                    _hoisted_4,
                    _createElementVNode("span", _hoisted_5, _toDisplayString(item.assign_time), 1)
                  ]),
                  _createElementVNode("div", {
                    class: "status",
                    style: _normalizeStyle({
              backgroundColor: item.statusInfo.backgroundColor,
              color: item.statusInfo.color,
            })
                  }, _toDisplayString(item.status_test), 5)
                ], 8, _hoisted_2))
              }), 128))
            ])
          ]),
          _: 1
        }, 8, ["loading", "error", "finished"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})